let pub_methods = {
  data() {
    return {
      mescrollDown: {
        textInOffset: this.$t("public.pullRefresh"),
        textOutOffset: this.$t("public.releaseRefresh"),
        textLoading: this.$t("public.loadtip"),
      }, //下拉刷新的配置. (如果下拉刷新和上拉加载处理的逻辑是一样的,则mescrollDown可不用写了)
    };
  },
  methods: {
    initScroll(mescroll) {
      this.mescroll = mescroll;
    },
    getscrollData() {
      return {
        auto: true,
        htmlLoading: `<p class="upwarp-progress mescroll-rotate"></p><p class="upwarp-tip">${this.$t(
          "public.loadtip"
        )}</p>`,
        callback: this.upCallback, // 上拉回调,此处可简写; 相当于 callback: function (page) { upCallback(page); }
        noMoreSize: 4, // 如果列表已无数据,可设置列表的总数量要大于半页才显示无更多数据;避免列表数据过少(比如只有一条数据),显示无更多数据会不好看; 默认5
        empty: {
          warpId: "dataList", // 父布局的id;
          icon: require("@/assets/img/new/no-date.png"),
          tip:
            "<p style='font-size:16px;'>" + this.$t("search.noData") + "</p>",
        },
        page: {
          num: 0,
          size: 10,
        },
        htmlNodata:
          '<p class="upwarp-nodata">' + this.$t("search.noMore") + "</p>",
      };
    },
    superAlert(msg) {
      this.$toast(msg);
    },
  },
  computed: {
    keyWord() {
      return this.$store.state.searchWord;
    },
  },
  watch: {
    keyWord() {
      this.mescroll.resetUpScroll(false); //切换tab时重置列表到第一页
    },
  },
};
export default pub_methods;
